import RouteWithAddedPropsAndPricesType from "@Route/types/RouteWithAddedPropsAndPrices.type";
import {FilterPopularFiltersType} from "@SearchResults/reducers/filterSlice";
import {useAppSelector} from "@Hooks/selector/useAppSelector";
import {isEmpty} from "@Array/isEmpty";

export default function useFilterByPopularFilter() {
    const {
        mTicket,
        instantConfirmation,
        webDiscount,
        direct,
    }: FilterPopularFiltersType = useAppSelector((state) => state.filter.filterPopularFilters)

    const filterByMTicket = (route: RouteWithAddedPropsAndPricesType) => {
        return route.status.hasMTicket
    }

    const filterByInstantConfirmation = (route: RouteWithAddedPropsAndPricesType) => {
        return route.status.isInstantConfirmation
    }

    const filterByDiscount = (route: RouteWithAddedPropsAndPricesType) => {
        return route.prices?.activeDiscount
    }

    const filterByDirectRoutes = (route: RouteWithAddedPropsAndPricesType) => {
        return (!route.travelInfo?.busChangeCount || route.travelInfo?.busChangeCount === 0)
            && isEmpty(route.travelInfo.busChange)
            && route.status?.isIntermodal === false
    }

    return {
        filterByMTicket,
        filterByInstantConfirmation,
        filterByDiscount,
        filterByDirectRoutes,
        direct,
        instantConfirmation,
        mTicket,
        webDiscount,
    }
}